<template>
  <div>
    <Modal v-if="show" :show="show" @close="closeModal">
      <div class="component">
        <h5 class="component-title">{{ modalTitle }}</h5>
        <div class="component-body">
          <div class="embed-responsive embed-responsive-16by9">
            <iframe
              class="embed-responsive-item"
              :src="'https://www.youtube.com/embed/' + modalVideo + '?rel=0'"
              allowfullscreen
              :title="modalTitle"
            ></iframe>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "VideoModal",
  props: {
    modalTitle: String,
    modalVideo: String,
    show: Boolean,
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.component {
  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
}
::v-deep {
  .modal-mask .modal-wrapper .modal-container {
    max-width: 900px;
    padding: 20px;
  }
  .modal-content {
    padding: 0;
  }
}
</style>
